/**
 * Detect fn
 */
export default () => 'ResizeObserver' in self
